import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NewsArticleDetail } from '@ats/api/cm';

@Component({
    selector: 'cm-announcement-detail',
    templateUrl: './cm-announcement-detail.component.html',
    styleUrls: ['./cm-announcement-detail.component.scss'],
    standalone: false
})
export class CmAnnouncementDetailComponent implements OnInit {
	@Input() announcement: NewsArticleDetail;

	constructor(private sanitizer: DomSanitizer) {}

	ngOnInit() {}

	sanitizeHtml(body: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(body);
	}

	checkPictureUrl(pictureUrl: string): string {
		return pictureUrl ? `url('${pictureUrl}')` : null;
	}
}
